export default {"src":"/ai/_next/static/media/copy_logo.98223ff9.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};